import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCv06SndoP4uCSTDZB4wV1rYanifG-WK60",
  authDomain: "netflix-clone-cf47e.firebaseapp.com",
  projectId: "netflix-clone-cf47e",
  storageBucket: "netflix-clone-cf47e.appspot.com",
  messagingSenderId: "39074744064",
  appId: "1:39074744064:web:e8d457a2acc575c5eed5e5",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth();
// const firebaseApp = firebase.initializeApp(firebaseConfig);
// const db = firebaseApp.firestore();
// const auth = firebase.auth();

export { app, auth };
